<template>
  <div class="modal">
    <div class="mask"></div>
    <div class="body">
      <slot>
        <slot name="header">
          <div class="header" v-html="title"></div>
        </slot>
        <slot name="body"></slot>
      </slot>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Modal',
    props: ['title'],
    data () {
      return {
        active: false
      }
    },
    created () {

    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  .modal {
    @include position(fixed, 0 0 0 0);
    z-index:10000;
  }

  .mask {
    @include position(fixed, 0 0 0 0);
    background:rgba($color-primary-darkest, .8);
  }

  .body {
    width:60%; max-width:80rem; min-width:30rem; background:$color-gray-lightest; margin:20vh auto 0; padding:4rem; position:relative; text-align:center;
    box-shadow:0 2px 12px 0 $color-gray-darkest;
  }

  .header {
    @include font-size(xlarge, $headline:true)
    margin-bottom:1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/Modal/index.vue